/** cookies 封装 */
let signalr: any = null
import Keys from "@/constant/key"
import signal from "@/utils/signalR"
import { Toast } from "vant"
// import Cookies from "js-cookie"

// export const getToken = () => Cookies.get(Keys.token)
// export const setToken = (token: string) => Cookies.set(Keys.token, token)
// export const removeToken = () => Cookies.remove(Keys.token)

// export const getExpiresIn = () => Cookies.get(Keys.expires_in)
// export const setExpiresIn = (expires_in: string) => Cookies.set(Keys.expires_in, expires_in)
// export const removeExpiresIn = () => Cookies.remove(Keys.expires_in)

// export const getRefreshToken = () => Cookies.get(Keys.refresh_token)
// export const setRefreshToken = (refresh_token: string) => Cookies.set(Keys.refresh_token, refresh_token)
// export const removeRefreshToken = () => Cookies.remove(Keys.refresh_token)

export const removeAll = () => () => localStorage.removeAll()

export const getToken = () => localStorage.getItem(Keys.token)
export const getCityCode = () => localStorage.getItem(Keys.cityCode)
export const getNoLoginCityCodeHome = () => sessionStorage.getItem(Keys.noLogincityCodeHome)
export const getNoLogincityCodeZy = () => localStorage.getItem(Keys.noLogincityCodeZy)
export const getNoLogincityCodeXm = () => localStorage.getItem(Keys.noLogincityCodeXm)
export const setToken = (token: string) => {
  // 提醒信息
  let message = ""

  signalr = signal(token)
  signalr.start()
  signalr.on("SendAll", (res: any) => {
    console.log(res, "收到消息")
    message = res
  })
  signalr.onclose((err: any) => {
    console.log(err)
    Toast(message)
  })
  localStorage.setItem(Keys.token, token)
}
export const removeToken = () => localStorage.removeItem(Keys.token)

export const getExpiresIn = () => localStorage.getItem(Keys.expires_in)
export const getTokenIn = () => localStorage.getItem(Keys.token)
export const setExpiresIn = (expires_in: string) => localStorage.setItem(Keys.expires_in, expires_in)
export const removeExpiresIn = () => localStorage.removeItem(Keys.expires_in)

export const getRefreshToken = () => localStorage.getItem(Keys.refresh_token)
export const setRefreshToken = (refresh_token: string) => localStorage.setItem(Keys.refresh_token, refresh_token)
export const removeRefreshToken = () => localStorage.removeItem(Keys.refresh_token)

export const getLoginTime = () => localStorage.getItem(Keys.login_time)
export const setLoginTime = (login_time: string) => localStorage.setItem(Keys.login_time, login_time)
export const removeLoginTime = () => localStorage.removeItem(Keys.login_time)
